<template>
  <div class="cabecera-pronostico">
    <h1 class="mb-0 titulo-pronostico">{{ producto.nombre }}</h1>
    <p class="nombre-tipster">{{ producto.tipstername }}</p>

    <div v-if="producto.descripcion" class="prod-desc" v-html="producto.descripcion"></div>

    <p v-if="tieneExpiracion" class="contador-expira mt-2">
      ⏳ {{ textoCuentaRegresiva }}
    </p>

    <!-- Precio final -->
    <p class="fw-bold mt-2">
      {{ $t('pronostico.totalToPay') }}

      <!-- Precio tachado: cuando hay descuento/rebaja, o cuando es trial (tacha el precio de suscripción) -->
      <span
        v-if="!pagoCompletado && ((producto?.rebaja_aplica || descuentoOK) || esTrial)"
        class="d-block mt-1"
        style="font-size:1.05rem; color:#dc3545; text-decoration: line-through; font-weight:600;"
      >
        <template v-if="producto?.rebaja_aplica || descuentoOK">
          {{ fmt(precioNormalMostrado) }}
        </template>
        <template v-else>
          {{ fmt(precioFinalMostrado) }}
        </template>
      </span>

      <!-- Precio verde: 0,00 para trial, precio final para el resto -->
      <span class="d-block" style="font-size:1.8rem; color:#28a745; font-weight:800; line-height:1.1;">
        <template v-if="esTrial && !pagoCompletado">{{ fmt(0) }}</template>
        <template v-else>{{ fmt(precioFinalMostrado) }}</template>
      </span>
    </p>

    <!-- Trial: hoy pagas 0 -->
    <div v-if="esTrial && !pagoCompletado" class="d-block mt-2">
      <span style="display:inline-block; padding:6px 14px; border-radius:999px; background:#fff3cd; color:#856404; font-weight:700; font-size:0.9rem;">
        🎁 {{ $t('pronostico.trialHoyPagas') }} {{ fmt(0) }} —
        {{ $t('pronostico.trialCargo', { days: diasGracia }) }}
        {{ fmt(precioFinalMostrado) }}/{{ labelPeriodoSuscripcion }}
      </span>
    </div>

    <!-- Badge SUSCRIPCIÓN: solo cuando NO es trial -->
    <div v-if="labelPeriodoSuscripcion && !esTrial" class="d-block mt-2">
      <span style="display:inline-block; padding:6px 12px; border-radius:999px; background:#e3f2fd; color:#1565c0; font-weight:700; font-size:0.9rem;">
        🔄 {{ $t('pronostico.subscriptionLabel') }} · {{ fmt(precioFinalMostrado) }}/{{ labelPeriodoSuscripcion }}
      </span>
    </div>

    <!-- Cupón de descuento -->
    <div v-if="descuentoDisponible" class="mb-3 text-start mt-4" style="max-width:400px;margin:0 auto;">
      <label class="form-label fw-semibold">{{ $t('pronostico.discountCode') }}</label>

      <div class="input-group input-group-cupon">
        <input
          type="text"
          :value="codigoDescuento"
          @input="$emit('update:codigoDescuento', $event.target.value)"
          class="form-control"
          :placeholder="$t('pronostico.discountPlaceholder')"
          :disabled="descuentoOK || bloquearUI || pagoCompletado"
        />
        <QBtn
          type="button"
          variant="tipster"
          :label="descuentoOK ? $t('pronostico.applied') : $t('pronostico.apply')"
          :disabled="descuentoOK || bloquearUI || pagoCompletado"
          @click.prevent="$emit('validar-descuento')"
        />
      </div>

      <small v-if="mensajeDescuento" :class="descuentoOK ? 'text-success' : 'text-danger'">
        {{ mensajeDescuento }}
      </small>
      <small class="text-muted d-block mt-1">{{ $t('pronostico.onlyOneCode') }}</small>
    </div>

  </div>
</template>

<script>
export default {
  name: "PronosticoCabecera",
  props: {
    producto: { type: Object, required: true },
    tieneExpiracion: { type: Boolean, default: false },
    textoCuentaRegresiva: { type: String, default: "" },
    descuentoDisponible: { type: Boolean, default: false },
    descuentoOK: { type: Boolean, default: false },
    bloquearUI: { type: Boolean, default: false },
    pagoCompletado: { type: Boolean, default: false },
    codigoDescuento: { type: String, default: "" },
    mensajeDescuento: { type: String, default: "" },
    precioNormalMostrado: { type: Number, default: 0 },
    precioFinalMostrado: { type: Number, default: 0 },
    ahorroMostrado: { type: Number, default: 0 },
    porcentajeAhorro: { type: Number, default: 0 },
    simboloMoneda: { type: String, default: "€" },
    moneda:        { type: String, default: "EUR" },
    diasGracia:    { type: Number, default: 0 },
  },
  emits: ["update:codigoDescuento", "validar-descuento"],
  methods: {
    fmt(amount) {
      const n = Number(amount).toFixed(2);
      const s = this.simboloMoneda;
      // Monedas con símbolo delante (convención anglosajona/latina con $)
      const antes = ['USD', 'MXN', 'ARS', 'CLP', 'COP'];
      return antes.includes(this.moneda) ? `${s}${n}` : `${n} ${s}`;
    },
  },
  computed: {
    esTrial() {
      return this.diasGracia > 0 && this.producto?.tipo_venta && this.producto.tipo_venta !== 'venta_unica';
    },
    labelPeriodoSuscripcion() {
      const map = {
        diario:     this.$t('pronostico.periodDiario'),
        semanal:    this.$t('pronostico.periodSemanal'),
        quincenal:  this.$t('pronostico.periodQuincenal'),
        mensual:    this.$t('pronostico.periodMensual'),
        trimestral: this.$t('pronostico.periodTrimestral'),
        semestral:  this.$t('pronostico.periodSemestral'),
        anual:      this.$t('pronostico.periodAnual'),
      };
      return map[this.producto?.tipo_venta] || null;
    },
  },
};
</script>
